import { apiService, FetchCategoriesResponse, FetchCategoriesQuery } from '../../'
import { stringify } from 'qs'

export const shopCategoriesService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getCategories: build.query<FetchCategoriesResponse, FetchCategoriesQuery>({
      query: ({ category = 'most-popular-retailers', locale = 'en-AU', sortBy = 'most_popular', perPage = '' }) => {
        const stringifiedParams = stringify({
          category,
          locale,
          sortBy,
          perPage,
        })
        return {
          url: `/api/v1/categories/${category}/stores?${stringifiedParams}`,
          method: 'get',
        }
      },
    }),
  }),
})
